import { Image } from '@/components/Image';

export function MainLogo() {
  return (
    <div className="fixed top-0 left-0 flex justify-between bg-white z-0 w-full">
      <div className="w-[260px] h-[75px] pl-6 flex items-center border-b border-[#f5f5f5]">
        <Image src="/images/bi.png" alt="bi" width={166} height={20} />
      </div>
    </div>
  );
}
